import React from "react";
import { hero } from "../mock";

const HERO_IMG =
  "https://images.unsplash.com/photo-1593425546383-260c8b86730b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400&ixlib=rb-4.1.0";
const WHITE_LOGO =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_twenty-proof/artifacts/m3wf26xs_20-Proof-Final-Logo-White.png";

const Hero = () => {
  const scrollToEpisode = () => {
    const el = document.getElementById("episodes");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative h-screen min-h-[640px] w-full flex items-center justify-center overflow-hidden">
      {/* Background photo */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="A 20-something walking through the decade of becoming"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/15" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-black/5" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,0,0,0.32)_0%,transparent_55%)]" />
      </div>

      {/* Accessible heading (visual is the logo lockup) */}
      <h1 className="sr-only">20 PROOF — The decade of becoming</h1>

      {/* Logo lockup */}
      <div className="relative z-10 px-6 w-full flex flex-col items-center">
        <img
          src={WHITE_LOGO}
          alt="20 PROOF — The decade of becoming"
          data-testid="hero-logo"
          className="hero-logo-in w-[80vw] max-w-[540px] drop-shadow-[0_8px_40px_rgba(0,0,0,0.6)]"
        />
        <button
          onClick={scrollToEpisode}
          data-testid="hero-cta"
          className="mt-12 inline-flex items-center border border-white/70 hover:bg-white hover:text-neutral-900 text-white font-sans-ui text-[15px] px-9 py-3.5 rounded-full transition-all duration-300 hover:scale-[1.03]"
        >
          {hero.cta}
        </button>
      </div>

      {/* scroll hint */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-[1px] h-12 bg-white/50 animate-pulse" />
      </div>
    </section>
  );
};

export default Hero;
